import { Arguments } from 'swr';
import SWRMiddleware from './SWRMiddleware';

type RefetchRequiredEndPointListType = [any, ...unknown[]] | readonly [any, ...unknown[]] | string;

const filterSWRKeys = (refetchRequiredEndPointList: RefetchRequiredEndPointListType) => (key: Arguments) => {
    return (
        Array.isArray(key) &&
        (Array.isArray(refetchRequiredEndPointList)
            ? refetchRequiredEndPointList.includes(key[0])
            : key[0] === refetchRequiredEndPointList)
    );
};

export { filterSWRKeys, SWRMiddleware };
export { type RefetchRequiredEndPointListType };
